const FULLWIDTH_DIGIT_OFFSET = 0xff10 - 0x30;
const FULLWIDTH_HYPHENS = /[－ー]/g;
const POSTAL_MARK = '〒';

function toHalfWidth(text: string): string {
	return text
		.replace(/[０-９]/g, (char) => String.fromCharCode(char.charCodeAt(0) - FULLWIDTH_DIGIT_OFFSET))
		.replace(FULLWIDTH_HYPHENS, '-');
}

function afterPostalMark(raw: string): string {
	const markIndex = raw.lastIndexOf(POSTAL_MARK);
	return markIndex === -1 ? raw : raw.slice(markIndex + 1);
}

/**
 * Extracts up to 7 postal-code digits from a raw input, with no formatting applied.
 *
 * When the postal mark (〒) is present, only the text after the last mark is
 * considered — this keeps address digits (street/building numbers) from
 * corrupting the code when a full address is pasted, e.g.
 * `東京都千代田区丸の内1-9-1 〒100-0005` yields `1000005` rather than `1911000`.
 *
 * Full-width digits are converted to half-width and every non-digit character
 * (including any hyphen) is dropped.
 */
function extractDigits(raw: string): string {
	return toHalfWidth(afterPostalMark(raw)).replace(/\D/g, '').slice(0, 7);
}

/**
 * Formats a value into the `ddd-dddd` shape, but only once it holds exactly 7 digits;
 * an incomplete value is returned as bare digits, unformatted. The field itself applies
 * no formatting — this runs on save (see normalizePostalCode), so the persisted value is
 * consistently hyphenated regardless of whether the supporter typed the hyphen themselves.
 */
export function formatJapanesePostalCode(raw: string): string {
	const digits = extractDigits(raw);

	return digits.length === 7 ? `${digits.slice(0, 3)}-${digits.slice(3)}` : digits;
}
